const translations = {
    deleteButton: 'Delete Selected'
};

export default translations;
